// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#Login input {
    font-size: 24px;
    margin: 5px 0;
    padding: 5px 10px;
}
`, "",{"version":3,"sources":["webpack://./src/Magor/login.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,aAAa;IACb,iBAAiB;AACrB","sourcesContent":["#Login input {\n    font-size: 24px;\n    margin: 5px 0;\n    padding: 5px 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
